export const FORMATS = {
    '.txt': 'text/plain',
    '.pdf': 'application/pdf',
}